import { render } from "./SettingsNIMList.vue?vue&type=template&id=746a6853"
import script from "./SettingsNIMList.vue?vue&type=script&lang=js"
export * from "./SettingsNIMList.vue?vue&type=script&lang=js"

import "./SettingsNIMList.vue?vue&type=style&index=0&id=746a6853&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__